module.exports = __webpack_public_path__ + "img/bg2.825f75e6.jpg";